import { render, staticRenderFns } from "./Doenca.vue?vue&type=template&id=92a4603a&scoped=true"
import script from "./Doenca.vue?vue&type=script&lang=js"
export * from "./Doenca.vue?vue&type=script&lang=js"
import style0 from "./Doenca.vue?vue&type=style&index=0&id=92a4603a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a4603a",
  null
  
)

export default component.exports